// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1126":"5e571b698148b8c0","2875":"f1c7350763960e36","4069":"3135041550836d7c","5487":"1964556dfa4ed71d"}[chunkId] + ".js";
};